import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-security-notice',
  templateUrl: './security-notice.component.html',
  styles: [
    `
      .border-info {
        width: fit-content;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule],
})
export class SecurityNoticeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
